<template>
  <div class="table-group">
    <div class="group-title"> 
      {{ locales(`${group.title}`) }}
    </div>
    <table-row v-for="(feature, index) in sortedBy()" :key="index" :feature="feature" :plans="plans" />
  </div>
</template>

<script>
import _ from 'lodash';
import tableRow from './tableRow.vue';

export default {
  components: {
    tableRow,
  },
  props: [
    'plans',
    'group',
  ],
  methods: {
    sortedBy() {
      return _.orderBy(this.features, 'order_in_category');
    },
  },
  data() {
    return {
      features: this.group.features,
      locales: __,
    };
  },
};
</script>

<style scoped src='../less/paymentPlans.less'></style>